import { render, staticRenderFns } from "./RangeBox.vue?vue&type=template&id=36dadba5&scoped=true&"
import script from "./RangeBox.vue?vue&type=script&lang=js&"
export * from "./RangeBox.vue?vue&type=script&lang=js&"
import style0 from "./RangeBox.vue?vue&type=style&index=0&id=36dadba5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dadba5",
  null
  
)

export default component.exports